import React, { useEffect, useState, useCallback } from "react";
import Flatpickr from "react-flatpickr";
import { Link } from "react-router-dom";
import { usePocketBase } from "../../PocketBaseContext";

const ReformUpcomingEvents = () => {
  const pb = usePocketBase();
  const [upcomingEvents, setUpcomingEvents] = useState([]);

  const fetchUpcomingEvents = useCallback(async () => {
    try {
      const now = new Date().toISOString();
      const records = await pb.collection("events").getFullList({
        filter: `start_date >= "${now}"`,
        sort: "start_date",
        limit: 10,
      });

      const formattedEvents = records.map((record) => ({
        id: record.id,
        title: record.title,
        start: new Date(record.start_date),
        end: record.end_date ? new Date(record.end_date) : null,
        description: record.description || "No description available",
        location: record.location || "No location",
      }));

      setUpcomingEvents(formattedEvents);
    } catch (error) {
      console.error("Error fetching upcoming events:", error);
    }
  }, [pb]);

  useEffect(() => {
    fetchUpcomingEvents();
  }, [fetchUpcomingEvents]);

  const formatTime = (date) => {
    const timeStr = new Date(date).toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
    const [time, period] = timeStr.split(' ');
    return (
      <>
        {time} <span className="text-uppercase">{period}</span>
      </>
    );
  };

  return (
    <div className="card">
      <div className="card-header border-0">
        <h4 className="card-title mb-0">Yaklaşan Etkinlikler</h4>
      </div>
      <div className="card-body pt-0">
        <div className="upcoming-scheduled">
          <Flatpickr
            className="form-control"
            options={{
              dateFormat: "d M, Y",
              inline: true,
              monthSelectorType: "dropdown"
            }}
          />
        </div>

        <h6 className="text-uppercase fw-semibold mt-4 mb-3 text-muted">Etkinlikler:</h6>
        {upcomingEvents.length > 0 ? (
          upcomingEvents.map((event) => (
            <div className="mini-stats-wid d-flex align-items-center mt-3" key={event.id}>
              <div className="flex-shrink-0 avatar-sm">
                <span className="mini-stat-icon avatar-title rounded-circle text-success bg-success-subtle fs-4">
                  {String(new Date(event.start).getDate()).padStart(2, '0')}
                </span>
              </div>
              <div className="flex-grow-1 ms-3">
                <h6 className="mb-1">{event.title}</h6>
                <p className="text-muted mb-0">{event.location}</p>
              </div>
              <div className="flex-shrink-0">
                <p className="text-muted mb-0">
                  {formatTime(event.start)}
                </p>
              </div>
            </div>
          ))
        ) : (
          <div className="mini-stats-wid d-flex align-items-center mt-3">
            <div className="flex-shrink-0 avatar-sm">
              <span className="mini-stat-icon avatar-title rounded-circle text-success bg-success-subtle fs-4">
                <i className="ri-calendar-event-line"></i>
              </span>
            </div>
            <div className="flex-grow-1 ms-3">
              <h6 className="mb-1">Etkinlik Bulunamadı</h6>
              <p className="text-muted mb-0">Yaklaşan etkinlik bulunmuyor</p>
            </div>
          </div>
        )}

        <div className="mt-3 text-center">
          <Link to="/reform-calendar" className="text-muted text-decoration-underline">
            Tüm Etkinlikleri Görüntüle
          </Link>
        </div>

      </div>
    </div>
  );
};

export default ReformUpcomingEvents;  